import React from 'react'
import { Icon, Link } from '@paypalcorp/pp-react'
import PropTypes from 'prop-types'
import styles from './passive_feedback_link.less'
import { getI18n } from 'client/i18n'

export const I18N_CONTEXT = 'components/pages/crowdfunding/pool_share'
const i18n = getI18n(I18N_CONTEXT)

const propTypes = {
  reloadQualtrics: PropTypes.function,
  uniqueFeedbackName: PropTypes.string,
}

const PassiveFeedbackLink = ({ reloadQualtrics, uniqueFeedbackName }) => {
  const handleClick = e => {
    e.preventDefault()
    reloadQualtrics(uniqueFeedbackName)
  }

  return (
    <div className={styles.passiveFeedbackLink}>
      <Icon name="chat" size="sm" />
      <Link href="/" onClick={handleClick}>
        {i18n('feedback_link')}
      </Link>
    </div>
  )
}

PassiveFeedbackLink.propTypes = propTypes
export default PassiveFeedbackLink
